import React, { Fragment, Suspense } from 'react'; 
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { LinearProgress } from '@material-ui/core';
import {connect} from 'react-redux'
import { Topbar } from './components';
import  renderRoutes  from '../../utils/renderRoutes.js';
const useStyles = makeStyles(theme => ({
  content: {
    height: '100%',
    paddingTop: 56,
    [theme.breakpoints.up('sm')]: {
      paddingTop: 64
    }
  }
}));

const Auth = props => {
  const { route } = props;

  const classes = useStyles();

  return (
    <Fragment>
      <Topbar />
      <main className={classes.content}>
        <Suspense fallback={<LinearProgress />}>
          {renderRoutes(route.routes,props.user)}
        </Suspense>
      </main>
    </Fragment>
  );
};

Auth.propTypes = {
  route: PropTypes.object
};


const mapStateToProps = state => { 
  return {
    user:state.session.user
  } }


export default connect(mapStateToProps,{})(Auth);
